export default __webpack_public_path__ + "fonts/字体下载.ed2c339b9a5f6d27a91b29a99440275d.png";